
import React from "react";
import { FormField, FormItem, FormLabel, FormControl } from "@/components/ui/form";
import { Switch } from "@/components/ui/switch";
import { useLanguage } from "@/context/LanguageContext";

interface PrivacyFieldsProps {
  form: any;
}

export const PrivacyFields: React.FC<PrivacyFieldsProps> = ({ form }) => {
  const { language } = useLanguage();

  return (
    <div className="space-y-4">
      <h3 className="text-lg font-medium">
        {language === 'en' ? 'Hide Landlord Name and Street Number' : '隱藏房東名稱及隱藏門牌號碼'}
      </h3>
      
      <div className="space-y-4">
        <FormField
          control={form.control}
          name="show_landlord_name"
          render={({ field }) => (
            <FormItem className="flex items-center justify-between p-3 bg-gray-50 rounded-lg">
              <div className="space-y-1">
                <FormLabel className="text-base font-medium">
                  {language === 'en' ? 'Hide Landlord Name' : '隱藏房東名稱'}
                </FormLabel>
                <p className="text-sm text-muted-foreground">
                  {language === 'en' 
                    ? 'If checked, landlord name will be hidden' 
                    : '若勾選，房東名稱將被隱藏'}
                </p>
              </div>
              <FormControl>
                <Switch
                  checked={!field.value}
                  onCheckedChange={(checked) => field.onChange(!checked)}
                />
              </FormControl>
            </FormItem>
          )}
        />

        <FormField
          control={form.control}
          name="hide_street_number"
          render={({ field }) => (
            <FormItem className="flex items-center justify-between p-3 bg-gray-50 rounded-lg">
              <div className="space-y-1">
                <FormLabel className="text-base font-medium">
                  {language === 'en' ? 'Hide Street Number' : '隱藏門牌號碼'}
                </FormLabel>
                <p className="text-sm text-muted-foreground">
                  {language === 'en' 
                    ? 'Address will only show street name and area' 
                    : '地址僅顯示街道名稱，不顯示門牌號碼'}
                </p>
              </div>
              <FormControl>
                <Switch
                  checked={field.value}
                  onCheckedChange={field.onChange}
                />
              </FormControl>
            </FormItem>
          )}
        />
      </div>
    </div>
  );
};
